module.exports = __webpack_public_path__ + "img/01_bg.4ce7acb8.png";